import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'react-bootstrap'
import { useStateValue } from '../../state'
import { client } from '@Utils'
import ButterToast, { Cinnamon } from 'butter-toast'
import { NewCourseModal } from '../modals/NewCourseModal'
import { RemoveConfirmModal } from '../modals/RemoveConfirmModal'
import { HealthCheckTable } from './HealthCheckTable'
import { ChangeCourseModal } from '../modals/ChangeCourseModal'

export const Context = ({ match }) => {
  const [currentState, dispatch] = useStateValue()
  const [newCourseModalOpen, toggleModal] = useState(false)
  const [removeModalOpen, toggleRemoveModal] = useState(false)
  const [removeModalURL, setRemoveModalURL] = useState('')
  const [removeModalMessage, setRemoveModalMessage] = useState('')
  const [removeModalTitle, setRemoveModalTitle] = useState('')
  const [getMembersError, setGetMembersError] = useState('')
  const [healthCheckData, setHealthCheckData] = useState('')
  const [healthCheckDataLoading, setHealthCheckDataLoading] = useState(false)
  const [healthCheckError, setHealthCheckError] = useState('')
  const [changeCourseModalOpen, toggleChangeCourseModal] = useState(false)
  const [changeCourseModalCoursenum, setChangeCouresModalCoursenum] =
    useState('')

  useEffect(() => {
    const getMembers = async () => {
      try {
        let membersResp = await client.get(
          `/account/admin_lti13.getContextMembers/-/${match.params.contextId}/`
        )
        dispatch({
          type: 'updateMembers',
          members: membersResp.data.members,
        })
      } catch (err) {
        if (err.response) {
          setGetMembersError(err.response.data.error)
          ButterToast.raise({
            content: (
              <Cinnamon.Crisp
                title={err.response.statusText}
                content={err.response.data.error}
                scheme={Cinnamon.Crisp.SCHEME_RED}
                icon={<i className="far fa-thumbs-down fa-3x" />}
              />
            ),
          })
        } else {
          setGetMembersError(err)
        }
      }
    }
    getMembers()
  }, [currentState.reloadSwitch])

  useEffect(() => {
    const getCourses = async () => {
      try {
        let contextCoursesResp = await client.get(
          `/account/admin_lti13.getContextCourses/-/${match.params.contextId}/`
        )
        dispatch({
          type: 'updateCourseTable',
          courseTableData: contextCoursesResp.data.contextCourses,
        })
        dispatch({
          type: 'updateContext',
          context: contextCoursesResp.data.context,
        })
      } catch (err) {
        if (err.response) {
          dispatch({ type: 'updateMessage', message: err.response.statusText })
          ButterToast.raise({
            content: (
              <Cinnamon.Crisp
                title={err.response.statusText}
                content={err.response.data.error}
                scheme={Cinnamon.Crisp.SCHEME_RED}
                icon={<i className="far fa-thumbs-down fa-3x" />}
              />
            ),
          })
        } else {
          dispatch({ type: 'updateMessage', message: err })
        }
      }
    }
    getCourses()
  }, [currentState.reloadSwitch])

  const openDeleteContextCourseModal = contextCourseObject => {
    setRemoveModalTitle('Remove Context Course')
    setRemoveModalURL(
      `/account/admin_lti13.deleteContextCourse/-/${contextCourseObject.id}/`
    )
    setRemoveModalMessage(
      `Are you sure you want to remove ${contextCourseObject.course.title} (${contextCourseObject.course.coursenum})?`
    )
    toggleRemoveModal(true)
  }
  const openDeleteMembersModal = context => {
    setRemoveModalTitle('Remove Context Members')
    setRemoveModalURL(
      `/account/admin_lti13.deleteContextMembers/${context.id}/`
    )
    setRemoveModalMessage(
      `Are you sure you want to delete all members for ${context.contextTitle}?`
    )
    toggleRemoveModal(true)
  }

  const fetchHealthData = async () => {
    setHealthCheckDataLoading(true)
    try {
      let healthData = await client.get(
        `/account/admin_lti13.contextHealthCheck/-/${match.params.contextId}`
      )
      const sanitizedData = healthData.data

      setHealthCheckData(sanitizedData)
      setHealthCheckDataLoading(false)
    } catch (err) {
      setHealthCheckError('Error error error')
    }
  }
  const openChangeCourseModal = contextCoursenum => {
    setChangeCouresModalCoursenum(contextCoursenum)
    toggleChangeCourseModal(true)
  }

  return (
    <div className="container" style={{ width: '100%' }}>
      <div className="mb-4">
        <div className="pull-right">
          <div
            className="btn btn-default btn-myed btn-default-myed btn-sm-myed"
            onClick={() => toggleModal(!newCourseModalOpen)}
          >
            <div className="far fa-plus fa-fw mr-2" /> Add New Course
          </div>
        </div>
        <Link
          className="btn btn-default btn-myed btn-default-myed btn-sm-myed mr-4"
          to={`/account/admin_lti13/-/platforms/${match.params.lmsCode}/issuers/${match.params.issuerId}/clients/${match.params.clientId}/deployments/${match.params.deploymentId}`}
        >
          <div className="far fa-arrow-circle-left fa-fw mr-2" /> Go Back
        </Link>
      </div>
      {currentState.context && (
        <div className="card-myed">
          <h3>Context Courses:</h3>
          <div>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Context Id:
              </span>{' '}
              {currentState.context.contextId}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Id:
              </span>{' '}
              {currentState.context.id}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Context Title:
              </span>{' '}
              {currentState.context.contextTitle}
            </p>
            <p>
              <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                Context Label:
              </span>{' '}
              {currentState.context.contextLabel}
            </p>
            <div className="flex flex-row my-2">
              <p>
                <span style={{ fontSize: '1.2em', fontWeight: 'bolder' }}>
                  Members:
                </span>{' '}
                {getMembersError ? (
                  <span style={{ color: 'rgb(184, 54, 52)' }}>
                    <i
                      className={`far fa-fw mr-4 color_red icon_color_red fa-exclamation-triangle`}
                    />
                    {getMembersError}
                  </span>
                ) : (
                  currentState.members.length
                )}
              </p>
              {currentState.members.length > 0 && (
                <a
                  onClick={() => openDeleteMembersModal(currentState.context)}
                  style={{ marginLeft: '1em' }}
                  className="btn btn-sm btn-sm-myed btn-danger"
                >
                  Remove <i className="far fa-window-close" />
                </a>
              )}
            </div>
          </div>
          <Table striped bordered condensed hover>
            <thead>
              <tr>
                <th>Course</th>
                <th>Coursenum</th>
                <th>Details</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentState.courseTableData.map((contextCourse, i) => (
                <tr key={i}>
                  <td>{contextCourse.context.contextTitle}</td>
                  <td>{contextCourse.course.coursenum}</td>
                  <td>
                    <Link
                      to={`/account/admin_lti13/-/platforms/${match.params.lmsCode}/issuers/${match.params.issuerId}/clients/${match.params.clientId}/deployments/${match.params.deploymentId}/contexts/${match.params.contextId}/contextCourses/${contextCourse.id}`}
                    >
                      View Course Links{' '}
                      {!currentState.context.lineitems && (
                        <i
                          className={`far fa-fw mr-4 color_red icon_color_red fa-exclamation-triangle`}
                        />
                      )}
                    </Link>
                  </td>
                  <td>
                    <a
                      onClick={() =>
                        openDeleteContextCourseModal(contextCourse)
                      }
                      className="btn btn-sm btn-sm-myed btn-danger"
                    >
                      Remove <i className="far fa-window-close" />
                    </a>
                    <a
                      onClick={() =>
                        openChangeCourseModal(contextCourse.course.coursenum)
                      }
                      className="btn btn-sm btn-sm-myed btn-warning ml-2"
                    >
                      Change Course <i className="far fa-edit" />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <NewCourseModal
            contextPk={match.params.contextId}
            show={newCourseModalOpen}
            toggle={toggleModal}
          />
          <RemoveConfirmModal
            modalTitle={removeModalTitle}
            message={removeModalMessage}
            endpoint={removeModalURL}
            show={removeModalOpen}
            toggle={toggleRemoveModal}
            currentState={currentState}
            dispatch={dispatch}
          />
          <ChangeCourseModal
            ctxId={currentState.context.id}
            ctxCoursenum={changeCourseModalCoursenum}
            show={changeCourseModalOpen}
            toggle={toggleChangeCourseModal}
            currentState={currentState}
            dispatch={dispatch}
          />
        </div>
      )}
      <button
        className="btn btn-default btn-myed btn-default-myed btn-sm-myed mb-4"
        disabled={healthCheckDataLoading}
        onClick={() => fetchHealthData()}
      >
        <div className="far fa-heartbeat mr-2" />{' '}
        {healthCheckDataLoading ? 'Analyzing...' : 'Start Health Check'}
      </button>
      {healthCheckError && (
        <div className="mt-3 text-danger">{healthCheckError}</div>
      )}
      {healthCheckData && <HealthCheckTable data={healthCheckData} />}
    </div>
  )
}
